import React from "react";
import { Alert, Box, Typography } from "@mui/material";

const DataCollectionInfo = () => (
  <Alert severity="info" sx={{ mb: 3 }}>
    <Box>
      <Typography variant="h8" gutterBottom>
        Data Collection Information
      </Typography>

      <Typography variant="body2" color="textSecondary" paragraph>
        Enter a location and radius to search OpenStreetMap for potential bar establishments to add to BarHopper. <br />
        Any establishments found will be stored as raw data for later review and processing.
      </Typography>
    </Box>
  </Alert>
);

export default DataCollectionInfo;
